import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import LoadMoreBtn from '../LoadMoreBtn';
import Loading from '../Loading';
import LabelsTable from '../LabelsTable';
import ListFilter from '../ListFilter';
import FollowedFilter from '../FollowedFilter';
import { useApi } from '../../context/ApiProvider';
import { Typography, Box } from '@mui/material';

const LabelsSection = ({
  dataFrom,
  title,
  hideTableInteraction,
  hideFilter,
  showFollowedFilter,
}) => {
  const [loading, setLoading] = useState(false);
  const [labels, setLabels] = useState([]);
  const [pagination, setPagination] = useState({});
  const [loadingMore, setLoadingMore] = useState(false);
  const [page, setPage] = useState(1);
  const [paginationConfig, setPaginationConfig] = useState({
    order_by: 'label_meta.latest_track_date',
    order_direction: 'desc',
  });
  const [followedFilter, setFollowedFilter] = useState(false);

  const api = useApi();

  useEffect(() => {
    loadLabels();
  }, [paginationConfig, dataFrom, followedFilter]);

  function onFilter(genre, sortBy, sortDirection) {
    setPaginationConfig({
      ...paginationConfig,
      genre: genre,
      order_direction: sortDirection,
      order_by: `label_meta.${sortBy}`,
    });
  }

  const handleFollowedFilterChange = (event) => {
    const newFollowedFilter = event.target.checked;
    setFollowedFilter(newFollowedFilter);
  };

  async function loadLabels() {
    setLoading(true);
    const endpoint = followedFilter
      ? dataFrom.replace('/labels', '/labels/followed')
      : dataFrom;
    const response = await api.get(endpoint, paginationConfig);
    if (response.ok) {
      const data = response.body.data ? response.body.data : response.body;
      setLabels(data);
      setPagination(response.body.pagination);
      setPage(1);
    } else {
      console.log(response);
    }
    setLoading(false);
  }

  async function loadMore() {
    setLoadingMore(true);
    const endpoint = followedFilter
      ? dataFrom.replace('/labels', '/labels/followed')
      : dataFrom;
    const response = await api.get(endpoint, {
      ...paginationConfig,
      offset: 20 * page,
    });
    if (response.ok) {
      setLabels([...labels, ...response.body.data]);
      setPagination(response.body.pagination);
      setPage(page + 1);
    } else {
      console.log(response);
    }
    setLoadingMore(false);
  }

  return (
    <>
      <Typography variant="h5" color={'white'}>
        {title}
      </Typography>
      {loading && (
        <Box textAlign="center">
          <Loading alterColor />
        </Box>
      )}
      <Box mb={6.5} textAlign="center" display={loading ? 'none' : 'block'}>
        <Box mb={2}>
          {!hideFilter && (
            <Box
              sx={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                mb: 2,
              }}
            >
              {showFollowedFilter && (
                <FollowedFilter
                  checked={followedFilter}
                  onChange={handleFollowedFilterChange}
                />
              )}
              <Box sx={{ display: 'flex', alignItems: 'center', marginTop: 2 }}>
                <ListFilter onFilter={onFilter} listType="labels" />
              </Box>
            </Box>
          )}
          <LabelsTable
            items={labels}
            onTableInteraction={setPaginationConfig}
            tableInteractionConfig={paginationConfig}
            hideTableInteraction={hideTableInteraction}
          />
        </Box>
        <Box textAlign="center">
          <LoadMoreBtn
            pagination={pagination}
            onLoadMoreClick={loadMore}
            loading={loadingMore}
          />
        </Box>
      </Box>
    </>
  );
};

LabelsSection.propTypes = {
  dataFrom: PropTypes.string,
  title: PropTypes.string,
  hideTableInteraction: PropTypes.bool,
  hideFilter: PropTypes.bool,
  showFollowedFilter: PropTypes.bool,
};

export default LabelsSection;
